import { useMutation } from '@tanstack/react-query'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/**
 * Mutation hook that emails a Stripe hosted payment link for a specific overdue
 * invoice. Sending an email changes no queried state, so it performs no cache
 * invalidation. `mutate` takes the Stripe invoice id and an optional recipient
 * email; omitted, the backend sends to the member.
 */
export function useSendInvoicePaymentLink(patientId: string) {
  const api = useOsApi()

  return useMutation({
    mutationFn: async ({ invoiceId, email }: { invoiceId: string; email?: string }) => {
      const response = await api.post(
        '/patients/:patientId/invoices/:invoiceId/send-payment-link',
        {
          params: { patientId, invoiceId },
          body: { email },
        }
      )
      if (!response.success) throw new Error(response.error.message)
      return response.data
    },
  })
}
